module.exports = __webpack_public_path__ + "assets/img/18_1744.71edc1af.jpg";